import CategoryView from "./CategoryView";

export default CategoryView;
